import { createSlice } from '@reduxjs/toolkit';
import { SpecialityType } from '../../components/categories/hooks/useSchema';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export interface Category {
  activeSpeciality: SpecialityType | null;
  modalId: string | null;
  extraModalData?: Record<string, any> | null;
}

const initialState: Category = {
  activeSpeciality: null,
  modalId: null,
  extraModalData: null,
};

export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setActiveSpecality: (state, action) => {
      state.activeSpeciality = action.payload;
    },

    setModalId: (state, action) => {
      state.modalId = action.payload?.modalId || null;
      state.extraModalData = action.payload?.extraData || null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setActiveSpecality, setModalId } = categorySlice.actions;
export const useCategoryState = () =>
  useSelector((state: RootState) => state?.category);

export default categorySlice.reducer;
